import { getLocalizedString, isPresent } from "@grandvisionhq/utils";
const getOfferings = (offerings, locale) => {
  if (!offerings) return void 0;
  return offerings.map((offering) => {
    return {
      title: getLocalizedString(offering.title, locale),
      subTitle: getLocalizedString(offering.subTitle, locale),
      originalPriceInformation: offering.price ? {
        // Map to a decimal for consistency with the other prices to allow calculations
        amount: offering.price?.value.centAmount / 100,
        currencyCode: offering.price?.value.currencyCode
      } : void 0,
      discountedPriceInformation: offering.price?.discounted?.value ? {
        // Map to a decimal for consistency with the other prices to allow calculations
        amount: offering.price.discounted.value.centAmount / 100,
        currencyCode: offering.price.discounted.value.currencyCode
      } : void 0,
      sku: offering.sku ?? void 0,
      icon: offering.icon ?? void 0,
      isInsuranceReimbursable: !!offering.isInsuranceReimbursable,
      bundleContentDescription: getLocalizedString(offering.bundleContentDescription, locale),
      actions: (offering.actions ?? []).filter(isPresent).map((action) => ({ action: action.action, variantSku: action.variant })),
      bundledProductSkus: offering.bundledProducts ?? []
    };
  });
};
export {
  getOfferings
};
//# sourceMappingURL=get-offerings.js.map
